export var UiGuideGroupKey;
(function (UiGuideGroupKey) {
    UiGuideGroupKey["start_guide"] = "start_guide";
    UiGuideGroupKey["boiler_circuit"] = "boiler_circuit";
    UiGuideGroupKey["heating_circuit"] = "heating_circuit";
    UiGuideGroupKey["simple_ui"] = "simple_ui";
})(UiGuideGroupKey || (UiGuideGroupKey = {}));
